import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedtag'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)

const GedTagRepository = {
  GetAll,
  Create,
  Update,
  Delete
}

export default GedTagRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedtag.js